import { useEffect } from "react";
import {
  UKPropertyInformationSelectionBaseContent,
  usePropertiesBySelection,
} from "./UKPropertyInformationSelectionSidebar/UKPropertyInformationSelectionSidebar";
import { Alert } from "react-migration/components/Alert";
import { InsightsSummaryAccordion } from "../../Bundle/Workbench/AssessmentTab/InsightsSummaryCard/InsightsSummaryAccordion";
import { LayerTypePrintableProps } from "../../types";
import { PropertyInformation } from "./UKPropertyInformationSelectionSidebar/useProperties";

function UKPropertyInformationSelectionContent({ properties }: { properties: PropertyInformation[] }) {
  if (!properties.length) {
    return <Alert.Info>No properties found for your selection</Alert.Info>;
  }

  return (
    <div className="flex flex-col">
      <UKPropertyInformationSelectionBaseContent properties={properties} />
    </div>
  );
}

export function UKPropertyInformationPrintable({ layer, selection, onLoaded, onUnmount }: LayerTypePrintableProps) {
  const { properties, loading } = usePropertiesBySelection(selection);

  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [onLoaded, loading]);

  useEffect(() => {
    return () => {
      onUnmount();
    };
  }, [onUnmount]);

  return (
    <InsightsSummaryAccordion>
      <InsightsSummaryAccordion.Item
        key={layer.id}
        value={layer.id}
        title="Properties on site"
        icon="icon-lt-home-line"
        loading={loading}
        hideLink={true}
      >
        <UKPropertyInformationSelectionContent properties={properties} />
      </InsightsSummaryAccordion.Item>
    </InsightsSummaryAccordion>
  );
}
